import {
  get,
  post,
  put,
  patch,
  del,
} from '@/utils/request';

const url = 'cards';

export function index(data) {
  return get({
    url,
    data,
  });
}

// 获取当前筛选条件下新老生办卡数量与实付金额（全量，不受分页影响）
export function getIsNewSummary(data) {
  return get({
    url: `${url}/is-new-summary`,
    data,
  });
}

export function getDailyCards({
  page, store_id, report_date, is_new,
}) {
  return get({
    url: `daily-${url}`,
    data: {
      page,
      store_id,
      report_date: report_date,
      is_new,
    },
  });
}

export function getAddRecordsByStudentId({
  student_id, page, size,
}) {
  return get({
    url: `${url}/records`,
    data: {
      student_id,
      page,
      size,
    },
  });
}

export function getDelayedCards(data) {
  return get({
    url: `${url}/delayed-cards`,
    data,
  });
}

// 获取已过期年卡的使用次数分析数据
export function getUsedNumberOfYearlyCard(data) {
  return get({
    url: `${url}/yearly-used-numbers`,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function getStoreId(id) {
  return get({
    url: `${url}/${id}/stores`,
  });
}

export function getCardIdByYouZanNumber({ you_zan_number, exclude_card_id, exclude_trial_payment_id }) {
  return get({
    url: `${url}/you-zan-numbers`,
    data: {
      you_zan_number,
      exclude_card_id,
      exclude_trial_payment_id,
    },
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

// 锁定某张课卡
export function lock(id) {
  return patch({
    url: `${url}/${id}/locks`,
  });
}

// 对某张课卡进行停卡（后台填写停卡天数 1 ~ 365 天）
export function stop(id, data) {
  return patch({
    url: `${url}/${id}/stops`,
    data,
  });
}

// 获取课卡小程序码（data.qr_type：1-延期，2-停卡）
export function getQrCode(id, data) {
  return patch({
    url: `${url}/${id}/qr-codes`,
    data,
  });
}


// 解锁某张课卡
export function unlock(id) {
  return del({
    url: `${url}/${id}/locks`,
  });
}

// 对某张课卡提前开卡（结束停卡）
export function unstop(id) {
  return del({
    url: `${url}/${id}/stops`,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function updateDate(
  id,
  data,
) {
  return patch({
    url: `${url}/${id}/dates`,
    data,
  });
}

// 课卡批量延期
export function updateDateBatch(data) {
  return put({
    url: `${url}/expire-times`,
    data,
  });
}

export function updateNumber(
  id,
  data,
) {
  return patch({
    url: `${url}/${id}/numbers`,
    data,
  });
}

export function updateType(
  id,
  data,
) {
  return patch({
    url: `${url}/${id}/types`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}
